import styled from '@emotion/styled';
import { css } from '@emotion/react';
export const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  padding: 0.5rem;
  border-bottom: 1px solid var(--theme-border, #e5e7eb);
  background-color: var(--theme-background, #ffffff);
  color: var(--theme-text, inherit);
  transition: all 0.3s ease;
  box-sizing: border-box;
  width: 100%;
  
  @media (max-height: 700px) {
    padding: 0.35rem;
  }
  
  @media (max-height: 600px) {
    padding: 0.25rem;
  }
  
  @media (max-height: 500px) {
    padding: 0.15rem;
    border-bottom-width: 1px;
  }
  
  ${(props)=>props.$opacity !== undefined && css`
    opacity: ${props.$opacity};
  `}
  
  ${(props)=>props.$translateY !== undefined && css`
    transform: translateY(-${props.$translateY}%);
  `}
  
  ${(props)=>props.$isVisible === false && css`
    visibility: hidden;
  `}
  
  &.compact {
    padding: 0.35rem;
  }
  
  &.very-compact {
    padding: 0.25rem;
  }
  
  &.ultra-compact {
    padding: 0.15rem;
  }
  
  &.vscode-header {
    position: sticky;
    top: 0;
    z-index: 100;
    
    opacity: 1 !important; 
    transform: none !important;
    visibility: visible !important;
    
    background-color: var(--vscode-editor-background, var(--theme-background, #ffffff));
    border-bottom-color: var(--vscode-editorWidget-border, var(--theme-border, #e5e7eb));
    color: var(--vscode-editor-foreground, var(--theme-text, inherit));
    
    body.vscode-dark &, html.vscode-dark & {
      background-color: var(--vscode-editor-background, #1e1e1e);
      border-bottom-color: var(--vscode-editorWidget-border, #454545);
    }
    
    body.vscode-light &, html.vscode-light & {
      background-color: var(--vscode-editor-background, #ffffff);
      border-bottom-color: var(--vscode-editorWidget-border, #e0e0e0);
    }
  }
`;
export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-height: 700px) {
    min-height: 36px;
  }
  
  @media (max-height: 600px) {
    min-height: 30px;
  }
  
  @media (max-height: 500px) {
    min-height: 24px;
  }
`;
export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const BackButton = styled.button`
  margin-right: 1rem;
  padding: 0.5rem;
  border-radius: 9999px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: var(--theme-text, currentColor);
  
  @media (max-height: 700px) {
    padding: 0.35rem;
    margin-right: 0.75rem;
  }
  
  @media (max-height: 600px) {
    padding: 0.25rem;
    margin-right: 0.5rem;
  }
  
  @media (max-height: 500px) {
    padding: 0.15rem;
    margin-right: 0.35rem;
  }
  
  &:hover {
    background-color: var(--theme-paper-hover, #f3f4f6);
  }
  
  svg {
    height: 1.25rem;
    width: 1.25rem;
    color: currentColor;
    
    @media (max-height: 700px) {
      height: 1.125rem;
      width: 1.125rem;
    }
    
    @media (max-height: 600px) {
      height: 1rem;
      width: 1rem;
    }
    
    @media (max-height: 500px) {
      height: 0.875rem;
      width: 0.875rem;
    }
  }
  
  .vscode-header & {
    color: var(--vscode-editor-foreground, var(--theme-text, currentColor));
    
    &:hover {
      background-color: var(--vscode-button-hoverBackground, var(--theme-paper-hover, rgba(90, 93, 94, 0.31)));
    }
  }
`;
export const Title = styled.h1`
  font-size: 1.25rem;
  font-weight: bold;
  color: var(--theme-text, #000000);
  margin: 0;
  
  @media (max-height: 700px) {
    font-size: 1.125rem;
    padding: 0.25rem 0;
  }
  
  @media (max-height: 600px) {
    font-size: 1rem;
    padding: 0.2rem 0;
  }
  
  @media (max-height: 500px) {
    font-size: 0.875rem;
    padding: 0.15rem 0;
  }
  
  .vscode-header & {
    color: var(--vscode-editor-foreground, var(--theme-text, currentColor));
  }
`;
export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;
export const Subtitle = styled.p`
  font-size: 0.875rem;
  color: var(--theme-text-secondary, #6b7280);
  margin: 0;
  line-height: 1.4;
  
  @media (max-height: 700px) {
    font-size: 0.8125rem;
  }
  
  @media (max-height: 600px) {
    font-size: 0.75rem;
  }
  
  @media (max-height: 500px) {
    font-size: 0.6875rem;
    line-height: 1.3;
  }
  
  .vscode-header & {
    color: var(--vscode-descriptionForeground, var(--theme-text-secondary, #6b7280));
  }
`;
export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  @media (max-height: 700px) {
    gap: 0.35rem;
    transform: scale(0.9);
    transform-origin: right center;
  }
  
  @media (max-height: 600px) {
    gap: 0.25rem;
    transform: scale(0.8);
    transform-origin: right center;
  }
  
  @media (max-height: 500px) {
    gap: 0.2rem;
    transform: scale(0.7);
    transform-origin: right center;
  }
  
  .vscode-header & button {
    color: var(--vscode-editor-foreground, var(--theme-text, currentColor));
    
    &:hover {
      background-color: var(--vscode-button-hoverBackground, var(--theme-paper-hover, rgba(90, 93, 94, 0.31)));
    }
  }
`;
export const RightContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  @media (max-height: 700px) {
    gap: 0.35rem;
  }
  
  @media (max-height: 600px) {
    gap: 0.25rem;
  }
  
  @media (max-height: 500px) {
    gap: 0.2rem;
  }
  
  color: var(--theme-text, inherit);

  .vscode-header & {
    color: var(--vscode-editor-foreground, var(--theme-text, inherit));
  }
`;
